import React, { Component } from 'react';

class DrawerSlideWrapper extends Component {
  drawerWrap = React.createRef();

  render() {
    const {
      isOpen,
      isLeft = false,
      isButtonOnly = false,
      isMenuSelect = false
    } = this.props;

    let classes = isLeft
      ? 'client-dash-drawer client-dash-drawer--left '
      : 'client-dash-drawer ';
    const direction = isLeft ? 'left' : 'right';
    // Being specific about true/false because on page load isOpen = null
    if (isOpen === true) {
      classes += `slide-in-${direction}`;
    } else if (isOpen === false) {
      classes += `slide-out-${direction}`;
    }

    if (isButtonOnly) classes += ' client-dash-drawer--button-only';
    if (isMenuSelect) classes += ' client-dash-drawer--menu-select';

    return (
      <div ref={this.drawerWrap} className={classes}>
        {this.props.children}
      </div>
    );
  }

  componentDidUpdate(prevProps) {
    const { isScrolledToTop } = this.props;

    if (isScrolledToTop && isScrolledToTop !== prevProps.isScrolledToTop) {
      // if true scroll back to top
      this.drawerWrap.current.scrollTop = 0;
    }
  }
}

export default DrawerSlideWrapper;



// WEBPACK FOOTER //
// ./src/components/new/DrawerSlideWrapper.js